import React from 'react';

export const PelotonLogo: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg
    width="104"
    height="32"
    viewBox="0 0 104 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.86373 15.8182C6.29226 15.8182 7.20203 15.1764 7.20203 13.6208C7.20203 12.0458 6.25048 11.446 4.86373 11.446H2.89684V15.8182H4.86373V15.8182ZM0 8.89453H4.94638C7.82321 8.89453 10.183 10.3246 10.183 13.6207C10.183 16.9174 7.80258 18.3693 4.94638 18.3693H2.89678V22.9932H0V8.89453V8.89453Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6665 8.66675H23.7173V11.2003H17.4817V14.4103H22.9736V16.8803H17.4817V20.134H23.9998V22.6667H14.6665V8.66675"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.6665 8.66675H31.5829V20.134H37.9998V22.6667H28.6665V8.66675"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.0167 15.9431C53.0167 13.311 51.2782 11.2995 48.7122 11.2995C46.1447 11.2995 44.4071 13.311 44.4071 15.9431C44.4071 18.5764 46.1447 20.5881 48.7122 20.5881C51.2782 20.5881 53.0167 18.5764 53.0167 15.9431V15.9431ZM41.4268 15.943C41.4268 11.7771 44.6554 8.70776 48.7123 8.70776C52.7685 8.70776 55.9963 11.7771 55.9963 15.943C55.9963 20.1104 52.7685 23.1794 48.7123 23.1794C44.6554 23.1794 41.4268 20.1104 41.4268 15.943V15.943Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.2524 11.2003H59.3335V8.66675H70.0002V11.2003H66.0813V22.6667H63.2524V11.2003"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84.7409 15.9431C84.7409 13.311 83.0024 11.2995 80.4362 11.2995C77.8689 11.2995 76.1302 13.311 76.1302 15.9431C76.1302 18.5764 77.8689 20.5881 80.4362 20.5881C83.0024 20.5881 84.7409 18.5764 84.7409 15.9431V15.9431ZM73.1499 15.943C73.1499 11.7771 76.3791 8.70776 80.4363 8.70776C84.493 8.70776 87.7213 11.7771 87.7213 15.943C87.7213 20.1104 84.493 23.1794 80.4363 23.1794C76.3791 23.1794 73.1499 20.1104 73.1499 15.943V15.943Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.762 16.5087C96.0732 15.8306 95.1194 14.5375 95.1194 14.5375C95.1194 14.5375 95.3229 16.127 95.3229 17.1653V23.2071H92.6665V8.66675H92.9495L99.9044 15.4927C100.574 16.1488 101.526 17.4618 101.526 17.4618C101.526 17.4618 101.344 15.8306 101.344 14.8352V8.79448H104V23.3334H103.718L96.762 16.5087"
      fill="white"
    />
  </svg>
);
